import { useAuth } from "@/lib/AuthContext";
import { Button } from "@/components/ui/button";
import { Eye, LogOut } from "lucide-react";

export function ImpersonationBanner() {
  const { impersonationInfo, stopImpersonating } = useAuth();

  if (!impersonationInfo || !impersonationInfo.is_impersonation) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-orange-600 text-white px-4 py-2 flex items-center justify-center gap-3 shadow-lg z-[9999]">
      <Eye className="w-5 h-5 animate-pulse" />
      <span className="font-medium text-sm sm:text-base">
        🔍 Mode Spectateur - Connecté comme <strong>{impersonationInfo.target_name}</strong>
      </span>
      <Button 
        size="sm" 
        variant="secondary"
        onClick={stopImpersonating}
        className="bg-white text-orange-600 hover:bg-orange-50 h-7 ml-2"
        data-testid="quit-impersonation-btn"
      >
        <LogOut className="w-3.5 h-3.5 mr-1" />
        Quitter
      </Button>
    </div>
  );
}
